
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Porder } from './porder';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';



export class PorderLine extends BaseEntity {

  porder            : Porder = new Porder();
  product           : Product = new Product();
  quantity          : number;

  returnedQuantity          : number;
  returnedDamagedQuantity1  : number;
  returnedDamagedQuantity2  : number;


  packs   :any[];

  constructor() {
    super();

  }
}
